import { useEffect } from "react";
import { useTodo } from "./Store";
import "./App.css";

export default function TodoApp() {
  const {
    tasks,
    newTask,
    editId,
    editText,
    loading,
    error,
    fetchTasks,
    setNewTask,
    handleAddTask,
    handleDeleteTask,
    handleToggleTask,
    handleEditTask,
    handleSaveEdit,
    handleCancelEdit,
  } = useTodo();

  useEffect(() => {
    fetchTasks();
  }, []);

  if (loading) return <p>Loading tasks...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div>
      <h1>..TO DO LIST..</h1>
      <div className="searchbar">
        <input
          type="text"
          value={newTask}
          onChange={(e) => setNewTask(e.target.value)}
          placeholder="Enter new task"
        />
        <button onClick={handleAddTask}>Add New Task</button>
      </div>

      <ul id="taskList">
        {tasks.map((task) => (
          <li key={task.id}>
            <div style={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
              <input
                type="checkbox"
                checked={task.completed}
                onChange={() => handleToggleTask(task.id)}
              />
              {editId === task.id ? (
                <input
                  type="text"
                  value={editText}
                  onChange={(e) => handleEditTask(task.id, e.target.value)}
                />
              ) : (
                <label className={task.completed ? "strikeTaskItem" : ""}>
                  {task.text}
                </label>
              )}
            </div>
            {editId === task.id ? (
              <>
                <button onClick={() => handleSaveEdit(task.id)}>Save</button>
                <button onClick={handleCancelEdit}>Cancel</button>
              </>
            ) : (
              <button onClick={() => handleEditTask(task.id, task.text)}>Edit</button>
            )}
            <button onClick={() => handleDeleteTask(task.id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
